<template>
  <div class="listen_content">
    <div class="content">
      <div class="title" v-if="startAnswerQues && questionList.length > 1">
        {{ curtQIndex + 1 + usedListLength }}/{{ questionList.length }}
      </div>
      <div class="text_content" v-if="!startAnswerQues">
        {{ content }}
      </div>
      <div v-else>
        <template v-for="(item, itemIndex) in questionList">
          <div
            v-if="curtQIndex == itemIndex"
            class="outer_question"
            :key="item.id"
          >
            <div>情景提示：</div>
            <div class="scene_tips">{{ item.content }}</div>
            <div
              class="question_outer"
              v-for="(itemLink, itemLinkIndex) in item.link"
              :key="itemLinkIndex"
            >
              <div v-if="itemLinkIndex == questionInnerIndex">
                <div>Question {{ itemLinkIndex + 1 }}:</div>
                <div class="question_item">{{ itemLink.question.title }}</div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <ExamFooter
      @endRecord="recorderEnd"
      :source="source"
      @goOnPlay="goOnPlay"
      @endDown="countDownEnd"
      :currentItem="currentItem"
      :isNewCountDown="isNewCountDown"
      :recordStatus="recorderStatus"
      :notifyReset="notifyReset"
      needRecord
    ></ExamFooter>
  </div>
</template>

<script>
import globalConfig from '@/store/global_config';
import { PUBLIC_DATA, indexToUpper } from '@/utils/common';
import ExamFooter from '../exam-footer';
import { formatUsedData } from './index';
import { showLoading, hideLoading } from '../../../../utils/common';
const { imgUrl, defaultRecordUrl } = PUBLIC_DATA;

export default {
  components: { ExamFooter },

  computed: {
    themeColor() {
      return globalConfig.state.themeColor;
    },
    evalAppId() {
      return globalConfig.state.evalAppId;
    },
    recorderStatus() {
      return globalConfig.state.recorderStatus;
    }
  },
  props: {
    itemInfo: {
      default: () => {},
      type: Object
    },
    bookId: {
      default: '',
      type: String
    },
    bookChapterId: {
      default: '',
      type: String
    },
    typeId: {
      default: '',
      type: String
    },
    gameId: {
      default: '',
      type: String
    },
    source: {
      default: '',
      type: String
    }
  },
  data() {
    return {
      imgUrl: imgUrl,
      // 当前问题索引
      curtQIndex: 0,
      // 倒计时文本
      countDownText: '',
      // 倒计时
      countDownNum: 0,
      // 开始答题
      startAnswerQues: false,
      // 作业要求
      content: '',
      // 问题列表
      questionList: [],
      // 倒计时数组(包含类型等)
      countDownArr: [],
      // 倒计时索引
      countDownIndex: 0,
      // 当前大问题的小问题索引
      questionInnerIndex: 0,
      // 当前问题
      currentQuestionInfo: {},
      // 引擎初始化状态
      initEngineStatus: false,
      // 正在请求保存数据
      isRequireLoading: false,
      // 总共的小题数量
      allListLength: 0,
      // 做过的小题数
      usedListLength: 0,
      // 当前倒计时右边的类型
      btnType: '',
      currentItem: {},
      isNewCountDown: false,
      notifyReset: false
    };
  },

  mounted() {
    const { introduce, questions: list } = this.itemInfo;
    this.allListLength = list.length;
    this.introduce = introduce || {};
    const {
      content,
      file_url: firstClaimUrl,
      audio_url: audioUrl,
      answer_time: answerTime,
      tips_time: tipsTime,
      score: sumScore,
      frequency
    } = introduce || {};
    this.content = content;
    // 如果是考试模式, 不保存进度
    const { newArr: filterUsed, onlyFilterNull } = formatUsedData(list);
    let questions = filterUsed;
    if (questions.length <= 0) {
      this.$emit('end');
      return;
    }
    this.usedListLength = this.allListLength - questions.length;
    globalConfig.commit(
      'changeFirstQuestion',
      !onlyFilterNull[0].link[0].question.used
    );
    const newArr = [];
    this.questionList = questions;
    // 第一个是要求
    newArr.push({
      type: 'audio',
      src: firstClaimUrl,
      text: '答题要求播放中',
      needPlusTime: true,
      btnType: 'jump'
    });
    const everyQuestionScore = sumScore / questions.length;
    questions.forEach((item, itemIdnex) => {
      const everyInnerScore = everyQuestionScore / item.link.length;
      item.link.forEach((innerItem, innerItemIndex) => {
        const { title, answer, file_url: itemAudioUrl } = innerItem.question;
        newArr.push({
          type: 'tips',
          time: tipsTime,
          text: '请阅读相关题目',
          innerIndex: innerItemIndex,
          outerQueIndex: itemIdnex,
          btnType: 'jump'
        });
        if (itemAudioUrl) {
          for (let i = 0; i < frequency; i++) {
            newArr.push({
              type: 'audio',
              src: itemAudioUrl,
              text: `第${indexToUpper[i]}遍`,
              btnType: 'jump'
            });
          }
        }
        newArr.push({
          type: 'audio',
          src: audioUrl || defaultRecordUrl,
          text: audioUrl ? '答题要求播放中' : '下面开始录音',
          btnType: 'jump',
          isFromLocal: !audioUrl
        });
        newArr.push({
          hisScore: everyInnerScore,
          // 问题
          question: title,
          // 答案
          answerObj: JSON.parse(answer),
          id: innerItem.question_id,
          type: 'tips',
          time: answerTime,
          isEnd: true,
          // 他是第几个大问题的子项
          outerQueIndex: itemIdnex,
          text: '录音中',
          btnType: 'record',
          // 他是问题中的第几个子项目
          innerIndex: innerItemIndex
        });
      });
    });
    this.countDownArr = newArr;
    this.startNextCountDown();
  },

  methods: {
    goOnPlay() {
      this.startNextCountDown();
    },

    // 失败回调函数(播放错误，等失败回调)
    errorCallback() {
      this.countDownIndex = this.countDownIndex - 1;
      this.countDownEnd();
    },

    startNextCountDown() {
      const countDownItem = this.countDownArr[this.countDownIndex];
      const { type, outerQueIndex, innerIndex, btnType } = countDownItem;
      console.log(countDownItem);
      this.notifyReset = false;
      this.btnType = btnType;
      this.currentItem = { ...countDownItem };
      if (type === 'tips') {
        this.startAnswerQues = true;
        this.questionInnerIndex = innerIndex;
        this.curtQIndex = outerQueIndex || this.curtQIndex;
      }
      setTimeout(() => {
        this.isNewCountDown = !this.isNewCountDown;
      }, 0);
    },

    countDownEnd() {
      // 如果正在录音还没保存就停止，保存完毕后回调用这个方法
      if (this.isRequireLoading) {
        return;
      }
      if (this.countDownIndex + 1 >= this.countDownArr.length) {
        console.log('已经是本类型最后一个了，需要触发父组件事件');
        this.$emit('end');
        return;
      }
      showLoading();
      this.countDownIndex += 1;
      // 验证当前播放结束的那个是不是这道题目的最后一个
      const countDownItem = this.countDownArr[this.countDownIndex];
      const { isEnd } = countDownItem;
      this.currentQuestionInfo = { ...countDownItem };
      //  倒计时结束，判断当前是不是录音选项，
      hideLoading();
      if (isEnd) {
        this.startRecord();
        return;
      }
      // 如果不是就开始下一个倒计时
      this.startNextCountDown();
    },

    startRecord() {
      const { id: questionId, hisScore } = this.currentQuestionInfo;
      globalConfig.commit('startRecorder', {
        elId: 'iRecorder',
        recordParams: {
          ...this.recordObj(),
          rank: hisScore
        },
        startCallback: () => {
          this.requestLoading = true;
          this.startNextCountDown();
        },
        getEvalMessage: data => this.handleSaveRecordData(data, questionId),
        stopCallback: () => {
          showLoading('评测中');
        },
        evalFailCallback: () => {
          this.requestLoading = false;
          this.errorCallback();
        },
        evalStopAndErrorCallback: () => {
          // 通知子组件需要重置了
          this.notifyReset = true;
        }
      });
    },

    // 停止录音
    recorderEnd() {
      globalConfig.commit('stopRecorder');
    },

    formatAnswerText(answerArr) {
      const newArr = [];
      answerArr.forEach(item => {
        newArr.push({
          text: item
        });
      });
      return newArr;
    },

    recordObj() {
      const { answerObj, question, time } = this.currentQuestionInfo;
      const newObj = {
        coreType: 'en.pqan.score',
        // 设置可能的正确回答;lm 中的每个 text 表示一种正确的回答
        lm: this.formatAnswerText(answerObj.text),
        // 提问问题的文本
        quest_ans: question,
        evalTime: time * 1000,
        // key 包括关键点可能的表述方式;关键点对打分的影响很大
        key: this.formatAnswerText(answerObj.key),
        attachAudioUrl: 1,
        phdet: 1,
        syllable: 1,
        syldet: 1,
        precision: 0.1,
        symbol: 1
      };
      return newObj;
    },

    handleSaveRecordData(data, questionId) {
      showLoading('请稍候');
      const payload = {
        question_id: questionId,
        book_chapter_id: this.bookChapterId,
        gameId: this.gameId,
        typeId: this.typeId,
        book_id: this.bookId,
        source: this.source,
        read_result: data
      };
      globalConfig.dispatch('submitUnitUserAnswer', payload).then(() => {
        setTimeout(() => {
          hideLoading();
          globalConfig.commit('changeFirstQuestion', false);
          this.isRequireLoading = false;
          // this.requestLoading = false;
          this.countDownEnd();
        }, 1000);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.listen_content {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 24px;
  .content {
    flex: 2;
    padding: 30rpx;
    box-sizing: border-box;
    background: white;
    overflow-y: scroll;
    border-radius: 8px;
    .title {
      font-size: 40rpx;
      background: #e9e9e9;
      border-radius: 15px;
      padding: 0 15px;
      color: gray;
      display: inline-block;
      margin-bottom: 10px;
    }
    .text_content {
      text-align: left;
      text-indent: 2em;
      color: #666;
    }
    .outer_question {
      text-align: left;
      .scene_tips {
        text-indent: 2em;
      }
      .question_outer {
        margin-top: 20px;
        .question_item {
          text-indent: 2em;
        }
      }
    }
  }
}
</style>
